module.exports = __webpack_public_path__ + "img/carrier.1bcd02bb.png";